module.exports = __webpack_public_path__ + "img/offline.eb38cc00.svg";